<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e183">
<p class="tx4" id="d41151421">Copyright © 2009 by Iain Levison </p>
<p class="tx4" id="d41151471">All rights reserved.</p>
<p class="tx4" id="d41151491">Published by Soho Press, Inc.</p>
<p class="tx4" id="d41151511">853 Broadway New York, NY 10003 </p>
<p class="tx4" id="d41151531">Library of Congress Cataloging-in-Publication Data </p>
<div class="tx14">
<p class="tx4" id="d41151551">Levison, Iain.</p>
</div>
<div class="tx15">
<p class="tx4" id="d41151571">How to rob an armored car / Iain Levison.</p>
</div>
<p class="tx4" id="d41151591">p. cm.</p>
<div class="tx16">
<p class="tx4" id="d41151611">ISBN 978-1-56947-599-7 1. Criminals--Fiction. 2. Pennsylvania--Fiction. I. Title.</p>
</div>
<div class="tx17">
<p class="tx4" id="d41151631">PS3612.E933H69 2009 813'.6--dc22</p>
<p class="jtp2" id="d41154789">2009011309 </p>
</div>
<div class="tx18">
<p class="tx4" id="d41151651">10 9 8 7 6 5 4 3 2 1 </p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap4_howtorob_9781569477113_epub_part4.vue?22aeea04